var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckWithStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.534 16.384v4.007H34v-.898l-3.11-3.11h-2.356zm2.345 9.175a1.743 1.743 0 1 0-2.465 2.465 1.743 1.743 0 0 0 2.465-2.465zm-1.233-1.444c-1.254 0-2.34.871-2.613 2.095h-1.74v-9.826H27.6v4.474c0 .258.209.466.467.466H34v4.886h-1.74a2.678 2.678 0 0 0-2.614-2.095zM17.334 25.56a1.743 1.743 0 0 0-2.973 1.142l-.002.09a1.743 1.743 0 1 0 2.975-1.232zm-3.326-14.185a4.69 4.69 0 1 0-6.634 6.634 4.69 4.69 0 0 0 6.634-6.634zm1.666.705h7.628a1.062 1.062 0 0 1 1.057 1.058V26.21h-5.644a2.677 2.677 0 0 0-5.226 0h-1.73a1.061 1.061 0 0 1-1.057-1.057v-4.838a5.625 5.625 0 0 0 4.972-8.236zm-6.025-.095a.465.465 0 0 1 .93 0v3.072h1.998a.465.465 0 0 1 0 .93h-2.464a.465.465 0 0 1-.464-.465v-3.537z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckWithStopwatch);
export default __webpack_public_path__ + "static/media/truck-with-stopwatch.3478de65adc57e871cff7b36f3b509c8.svg";
export { ForwardRef as ReactComponent };